import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import "../components/general.css"
import * as contactStyle from "../components/contact.module.css"

const DisplayContact = () => {

  React.useEffect(() => {
  })

  return (
    <>
      <section className={contactStyle.contactSection}>

        <div className={contactStyle.headerImage}>
          <StaticImage
            src="../images/contact_header_imagewebp.png"
            alt="Image d'arrière-plan"
            placeholder="blurred"
            formats={["auto", "webp", "avif"]}
          />
          <h1>Contactez-nous</h1>
        </div>

        <div className={contactStyle.contactMainWrapper}>

          <div className={contactStyle.firstRow}>
            <div>
              <p>
                Envie de plus d’informations pour la revente ou la réparation de votre mobile ?<br /><br />
                Vous pouvez nous contacter avec les liens ci-dessous ou venir en boutique au <a href="https://goo.gl/maps/QfY47WW27HEhZeao6">centre commercial Carrefour Riom Sud</a> pour recevoir des conseils personnalisés de nos experts.
              </p>
            </div>
            <div className={contactStyle.googleMapIframe}>
              <iframe loading="lazy" title="Map" style={{ border: "0", height: "30vh", width: "100%", marginTop: "-59px" }}
                src="https://www.google.com/maps/d/u/1/embed?mid=1_DAlp-xo_Zbsh-8r8zBrxvT8OBU2iyW7&output=embed" allowFullScreen=""
                frameBorder="0" data-rocket-lazyload="fitvidscompatible" className="lazyloaded" data-ll-status="loaded">
              </iframe>
              <noscript>
                <iframe title="Map" style={{ border: "0", height: "30vh", width: "100%", marginTop: "-59px" }}
                  src="https://www.google.com/maps/d/u/1/embed?mid=1_DAlp-xo_Zbsh-8r8zBrxvT8OBU2iyW7&output=embed" allowFullScreen=""
                  frameBorder="0">
                </iframe>
              </noscript>
            </div>

          </div>

          <div className={contactStyle.secondRow}>
            <p>
              Sinon vous pouvez aussi nous contacter par mail:<br />
            </p>
            <a
              className={contactStyle.contactLink}
              href="mailto:mobilelabs63men@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              Envoyer un mail
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l3.235 1.94a2.76 2.76 0 0 0-.233 1.027L1 5.384v5.721l3.453-2.124c.146.277.329.556.55.835l-3.97 2.443A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741l-3.968-2.442c.22-.28.403-.56.55-.836L15 11.105V5.383l-3.002 1.801a2.76 2.76 0 0 0-.233-1.026L15 4.217V4a1 1 0 0 0-1-1H2Zm6 2.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z" />
              </svg>
            </a>
            <br />
            <br />
            <p>
              Ou par téléphone:<br />
            </p>
            <a className={contactStyle.contactLink} href="tel:+33987740045">Appeler <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
            </svg>
            </a>
          </div>

        </div>
      </section>
    </>
  )
}

export default DisplayContact